import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Notification } from 'components/CustomNotification';
import {
  PersonalContainer,
  SubmitContainer,
} from 'pages/addprofile/Profile.style';
import { Input, Button, Select, BrandIconSpinner } from 'components';
import TextEditor from 'components/TextEditor';
import {
  getCompanyProfileByuserId,
  updateCompanyList,
} from 'redux/features/CompanySlice';
import { companySizeList, DateList, MonthList, YearList } from 'assert/OptionList';
import moment from 'moment';

const CompanyDetails = ({ personalData, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [loading, setLoading] = useState(false);
  const [textLength, setTextLength] = useState(0);
  const [companyDetails, setCompanyDetails] = useState({
    name: '',
    size: '',
    title: '',
    url: '',
    headQuarters: '',
    day: '',
    month: '',
    year: '',
    descriptions: '',
  });
  const [errMsg, setErrmsg] = useState({
    name: '',
    size: '',
    title: '',
    url: '',
    descriptions: '',
    day: '',
    month: '',
    year: '',
  });

  const resetFields = () => {
    Object.keys(companyDetails).forEach((data) => {
      companyDetails[data] = '';
    });
    Object.keys(errMsg).forEach((data) => {
      errMsg[data] = '';
    });
    setCompanyDetails((prevState) => ({
      ...prevState,
    }));
    setErrmsg((prevState) => ({
      ...prevState,
    }));
    setLoading(false);
    onClose(false, 'company');
  };

  useEffect(() => {
    const { name, size, title, url, dob, headQuarters, descriptions } =
      personalData.details || {};
    setCompanyDetails((prevState) => ({
      ...prevState,
      name: name || '',
      size: size || '',
      title: title || '',
      url: url || '',
      headQuarters: headQuarters || '',
      descriptions: descriptions || '',
      day: dob?.split('-')?.[2] || '',
      month: dob?.split('-')?.[1] || '',
      year: dob?.split('-')?.[0] || '',
    }));
  }, [personalData]);

  const handleChange = useCallback(
    (data, name) => {
      setCompanyDetails((prevState) => ({
        ...prevState,
        [name]: data,
      }));
    },
    [companyDetails]
  );

  const handleValidation = useCallback(() => {
    const validationParams = { ...errMsg };

    ['name', 'size', 'title', 'url'].map((val) =>
      companyDetails[val]?.trim() === ''
        ? (validationParams[val] = 'Field Required')
        : (validationParams[val] = '')
    );
    if (textLength === 0) {
      validationParams.descriptions = 'Field Required';
    } else if (textLength > 5000) {
      validationParams.descriptions = 'Max limit 5000';
    } else {
      validationParams.descriptions = '';
    }

    setErrmsg(validationParams);
    return Object.keys(errMsg).every((it) => validationParams[it] === '');
  }, [errMsg, companyDetails, textLength]);

  const handleSubmit = () => {
    const { day, month, year } = companyDetails;
    if (moment().diff(moment(`${year}-${month}-${day}`), 'years') < 13) {
      Notification('error', 'Sorry, users must be 13 or older.');
      return;
    }
    if (handleValidation()) {
      setLoading(true);
      const formData = new FormData();
      const companyDetailsList = [
        "name",
        "size",
        "title",
        "url",
        "headQuarters",
        "descriptions",
      ];
      companyDetailsList.map((data) =>
        formData.set(data, companyDetails[data])
      );
      formData.set("dob", `${year}-${month}-${day}`)
      dispatch(updateCompanyList(formData))
        .then(() => {
          dispatch(getCompanyProfileByuserId(getProfile?.username));
          resetFields();
          Notification('success', 'Updated Successfully');
        })
        .catch((err) => {
          resetFields();
          Notification('warning', err.response?.data?.message);
        });
    }
  };

  return (
    <>
      <BrandIconSpinner loading={loading} />
      <PersonalContainer>
        <div className="field-wrap">
          <Input
            label={'Company Name'}
            value={companyDetails.name}
            onChange={(data) => handleChange(data, 'name')}
            errMsg={errMsg.name}
            required
          />
          <Select
            Options={companySizeList}
            label={'Company Size'}
            value={companyDetails.size || ''}
            onChange={(data) => handleChange(data?.target?.value, 'size')}
            errMsg={errMsg.size}
            required
          />
        </div>
        <Input
          label={'Title'}
          value={companyDetails.title}
          onChange={(data) => handleChange(data, 'title')}
          errMsg={errMsg.title}
          required
        />
        <Input
          label={'Company Website'}
          value={companyDetails.url}
          onChange={(data) => handleChange(data, 'url')}
          errMsg={errMsg.url}
          required
        />
        <Input
          label={'Headquarter'}
          value={companyDetails.headQuarters}
          onChange={(data) => handleChange(data, 'headQuarters')}
        />
        <div className="company-date-container">
          <div className="lebelView">
            <label>
              Enter your D.O.B <span className="requiredSymbol">*</span>
            </label>
          </div>
          <div className="date-select-field">
            <Select
              Options={MonthList}
              value={companyDetails.month}
              onChange={(data) => handleChange(data.target.value, 'month')}
            />
            <Select
              Options={DateList}
              value={companyDetails.day}
              onChange={(data) => handleChange(data.target.value, 'day')}
            />
            <Select
              Options={YearList}
              value={companyDetails.year}
              onChange={(data) => handleChange(data.target.value, 'year')}
            />
          </div>
        </div>
        <TextEditor
          defaultValue={''}
          label={'Descriptions'}
          required
          onChange={(data) => handleChange(data, 'descriptions')}
          value={companyDetails.descriptions}
          errMsg={errMsg.descriptions}
          maxLength={5000}
          callbackTextLength={setTextLength}
        />
      </PersonalContainer>
      <SubmitContainer className="modal-footer company-btn">
        <Button label={'Update'} onClick={handleSubmit} type="text" />
        <Button label={t('Close')} onClick={resetFields} type="text" />
      </SubmitContainer>
    </>
  );
};
export default CompanyDetails;
